<template>
  <div>
    <textarea v-model="rollRstMsg" rows="20" style="width: 90%;"></textarea>
    
    <van-row style="margin-top: 30px;" v-if="rollIndex < luckRules.length">
      <van-col :span="22" :offset="2">
        本轮是第 {{ rollIndex + 1 }} 轮摇奖【{{ title }}】，共 {{ currCount }} 名
      </van-col>
    </van-row>
    <van-row v-else>
      <van-col :span="22" :offset="2">
        本局摇奖结束
      </van-col>
    </van-row>

    <van-row style="margin-top: 30px;">
      <van-col :span="10" :offset="1">
        <van-button type="primary" size="large" :disabled="(rollIndex + 1) > luckRules.length"
          @click="play">摇奖</van-button>
      </van-col>
      <van-col :span="10" :offset="1">
        <van-button size="large" @click="reset">重置</van-button>
      </van-col>
    </van-row>

    <van-row>
      <van-col :span="24">
        摇奖池号码：
      </van-col>
    </van-row>
    <van-row>
      <van-col v-for="num in randNumArray" :key="num"
        :span="4" v-if="randNumArray && randNumArray.length > 0">
        {{ num }}
      </van-col>
    </van-row>
  </div>
</template>

<script>
export default {
  name: 'LuckPlay',
  data() {
    return {
      randNumArray: [],
      luckRules: [
        ['特等奖', 5],
        ['一等奖', 15],
        ['二等奖', 30],
        ['三等奖', 30]
      ],
      rollIndex: 0,
      title: '',
      currCount: 0,
      rollRstMsg: ''
    }
  },
  mounted() {
    this.reset()
  },
  methods: {
    reset() {
      this.randNumArray = []
      for (let i = 1; i <= 80; i++) {
        this.randNumArray.push(i)
      }

      this.rollIndex = 0
      this.rollRstMsg = ''
      this.setRollTip(this.luckRules[0])
    },
    setRollTip(rule) {
      this.title = rule[0]
      this.currCount = rule[1]
    },
    randRoll() {
      const newRstArray = []
      for (let i = 1; i <= this.currCount; i++) {
        const ranIdx = Math.floor(Math.random() * this.randNumArray.length)
        const num = this.randNumArray[ranIdx]
        newRstArray.push(num)
        this.randNumArray.splice(ranIdx, 1)
      }
      this.rollRstMsg += `\n\n【${this.title}】结果\n${newRstArray.join(', ')}`
    },
    play() {
      if (this.rollIndex < this.luckRules.length) {
        this.randRoll()
        this.rollIndex++
        if (this.rollIndex < this.luckRules.length) {
          const rule = this.luckRules[this.rollIndex]
          this.setRollTip(rule)
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/luck-play/play.vue